<template>
  <div>

    <div class="container xy_container">
      这是教程页
    </div>
  </div>
</template>

<script>
import xyCard from '../components/xy_card'

export default {
  name: 'index',
  data: function () {
    return {
      keyword: ''
    }
  },
  methods: {
    showSuccess () {

    }
  },
  components: {

    xyCard
  },
  mounted () {
    // this.axios.get('http://www.baidu.com').then((response) => {
    //   console.log(response.data)
    //   this.taskQ = response.data
    // })
  }
}
</script>
<style scope>
.xy_container {
  margin-top: 10px;
}

.work_menu_list {
  box-shadow: 0px 0px 6px #666;
  padding-bottom: 100px;
}

.xy_card {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/app/course.vue